export const CREATE_PACKAGE = 'CREATE_PACKAGE';
export const DELETE_PACKAGE = 'DELETE_PACKAGE';
export const SAVE_PACKAGE = 'SAVE_PACKAGE';
export const UPDATE_PACKAGE = 'UPDATE_PACKAGE';
export const UPDATE_PACKAGES_LIST = 'UPDATE_PACKAGES_LIST';
export const UPDATE_PACKAGE_SUMMARY_DATE_RANGE = 'UPDATE_PACKAGE_SUMMARY_DATE_RANGE';
